module.exports = __webpack_public_path__ + "media/images/top/qa/human-2-dcf0e92f360541f87ca4d04e76d2807e.png";